// Device information collection utility
import { getFirebaseToken } from './firebaseUtils';

export async function getDeviceInfo() {
    const userAgent = navigator.userAgent;
    
    // Detect platform
    let devicePlatform = 'web';
    if (/Android/i.test(userAgent)) {
        devicePlatform = 'android';
    } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
        devicePlatform = 'ios';
    }
    
    // Get OS version
    let osVersion = 'unknown';
    if (/Android/i.test(userAgent)) {
        const match = userAgent.match(/Android\s([0-9.]+)/);
        osVersion = match ? match[1] : 'unknown';
    } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
        const match = userAgent.match(/OS\s([0-9_]+)/);
        osVersion = match ? match[1].replace(/_/g, '.') : 'unknown';
    }
    
    // Get device model
    let deviceModel = 'unknown';
    if (/Android/i.test(userAgent)) {
        const match = userAgent.match(/;\s([^;]+)\sBuild/);
        deviceModel = match ? match[1] : 'unknown';
    } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
        const match = userAgent.match(/(iPhone|iPad|iPod)/);
        deviceModel = match ? match[1] : 'unknown';
    }
    
    // Get timezone
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    
    // Get language
    const language = navigator.language || navigator.languages[0] || 'en';
    
    // Generate device ID (use existing or create new)
    let deviceId = localStorage.getItem('device_id');
    if (!deviceId) {
        deviceId = `web_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        localStorage.setItem('device_id', deviceId);
    }
    
    // Try to get Firebase token
    let firebaseToken = '';
    try {
        const token = await getFirebaseToken();
        firebaseToken = token || '';
    } catch (error) {
        console.warn('Could not get Firebase token:', error);
        firebaseToken = '';
    }

    return {
        device_id: deviceId,
        firebase_token: firebaseToken, // Real Firebase token or empty string
        platform: devicePlatform,
        os_version: osVersion,
        app_version: process.env.REACT_APP_VERSION || '1.0.0',
        device_model: deviceModel,
        timezone: timezone,
        language: language,
        location: null // Will be set when geolocation is available
    };
}

// Get user's location
export function getCurrentLocation() {
    return new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
            reject(new Error('Geolocation is not supported'));
            return;
        }
        
        navigator.geolocation.getCurrentPosition(
            (position) => {
                resolve({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude
                });
            },
            (error) => {
                console.warn('Geolocation error:', error);
                resolve(null); // Don't reject, just return null
            },
            {
                timeout: 10000,
                enableHighAccuracy: false
            }
        );
    });
}

// Get country and city from coordinates (reverse geocoding)
export async function getLocationInfo(latitude, longitude) {
    try {
        // Using a free reverse geocoding service
        const response = await fetch(
            `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
        );
        
        if (!response.ok) {
            throw new Error('Reverse geocoding failed');
        }
        
        const data = await response.json();
        return {
            country: data.countryName || 'Unknown',
            locality: data.city || data.locality || 'Unknown'
        };
    } catch (error) {
        console.warn('Reverse geocoding error:', error);
        return {
            country: 'Unknown',
            locality: 'Unknown'
        };
    }
}
